var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
export function onFileDuplicateNotExists(request, fileStorage, onFileDuplicateNotExists) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fileStorage.isFileExists(request);
        if (response.exists) {
            showAlertSnackbar({
                type: 'error',
                message: `${response.directory ? 'Directory' : 'File'} already exists with name ${response.file.columns.name}`,
            });
        }
        else {
            onFileDuplicateNotExists();
        }
    });
}
